
export const lingua_it = {
  lang: "it",
  title: "3D SHIRT - Configuratore 3D per camicie su misura",
  description: "Configuratore 3D per camicie su misura",
  personalizza: "Personalizza",
  misure: "Misure",
  tessuto: "Tessuto",
  filtri: "Filtri",
  scegliTessuto: "Scegli il tessuto",
  cercaTessuto: "Cerca tessuto...",
  inOfferta: "In offerta",
  nonDisponibile: "Non disponibile",
  colore: "Colore",
  colori: "Colori",
  tuttiColori: "Tutti i colori",
  bianco: "Bianco",
  celeste: "Celeste",
  altriColori: "Altri colori",
  disegno: "Stoffe",
  disegni: "Stoffe",
  tuttiDisegni: "Tutte le stoffe",
  tintaUnita: "Stoffe tinte unite",
  righe: "Stoffe rigate",
  quadretti: "Stoffe a quadri",
  fantasia: "Stoffe fantasia stampate",
  materiale: "Materiale",
  materiali: "Materiali",
  tuttiMateriali: "Tutti i materiali",
  cotone: "Cotone",
  lino: "Lino",
  brand: "Brand",
  brands: "Brands",
  tuttiBrands: "Tutti i brands",
  codice: "Codice",
  ordina: "Ordina per prezzo",
  basso: "Dal prezzo più basso",
  alto: "Dal prezzo più alto",
  lato: "Vista laterale",
  front: "Vista frontale",
  retro: "Vista retro",
  piegata: "Vista piegata",
  extra: {
    tutti: "Tutti i prodotti",
    selTaglia: "Seleziona la taglia",
    desc: "Descrizione",
    correlati: "Prodotti correlati",
  },
  bubble: {
    prima: "Clicca qui per tornare alla vista camicia.",
    seconda: "Trascina con il tasto SINISTRO del mouse per ruotare la camicia",
    terza: "Trascina con il tasto DESTRO del mouse per spostare la camicia.",
    quarta: "Muovi la ROTELLINA del mouse per lo zoom.",
    quinta: "OK, CHIUDI",
    sesta: "Trascina con un dito per ruotare la camicia.",
    settima: "Trascina con due dita per spostare la camicia.",
    ottava: "Allarga o stringi con due dita per lo zoom.",
  },
  banner: {
    titolo: "Uso dei Cookie",
    testo1:
      "In questa applicazione, facciamo uso di cookie (o tecnologie similari) per memorizzare informazioni nel tuo computer o dispositivo mobile al fine di migliorare la tua esperienza online. I cookie sono piccoli file di testo che ti consentono di navigare in modo efficiente, ricordare le tue preferenze, aiutarci a comprendere la performance dell'applicazione e migliorare in generale la tua esperienza di utilizzo.",
    testo2:
      "Chiudendo questo messaggio acconsenti all'utilizzo dei cookie in base alle tue (eventuali) preferenze.",
    gestione: "Gestione dei cookie",
    acconsento: "Acconsento",
  },
  sito: {
    titolo: "La tua camicia su misura direttamente dal produttore!",
    sottotitolo:
      "La nostra è un’azienda ad impronta artigianale e negli anni ha condiviso la passione per questo lavoro con un valido gruppo di esperte lavoratrici che con grande spirito di sacrificio ha saputo mantenere i legami con le proprie radici culturali dalla forte tradizione sartoriale.",
    bottone1: "Inizia a creare la tua camicia!",
    titolo2: "Un configuratore 3D senza limiti",
    sottotitolo2:
      "La camiceria Su Misura di Lodi produce e vende per aziende e privati",
    configura: "Configura",
    titolo3: "CAPI DI VERA MODA ARTIGIANALE ITALIANA!",
    sottotitolo3:
      "Offriamo tutta la nostra esperienza per confezionare camicie di qualità interamente fatte a mano secondo la tradizione sartoriale italiana.",
    titolo4: "Qualità delle immagini",
    sottotitolo4:
      "Scegli una camicia su misura, ti garantiamo una",
    titolo5: "VESTIBILITA' PERFETTA",
    sottotitolo5:
      "ed un elevato confort perchè si tratta di un capo tagliato sulla persona in base alla corporatura e alle esigenze specifiche del cliente.",
    sottotitolo6:
      "Per la nostra produzione impieghiamo",
    titolo7: "MATERIE PRIME ECCELLENTI",
    sottotitolo7:
      "100% Cotone doppio ritorto prodotto dalle migliori aziende italiane quali: Albini, Canclini, Canaloni, Monti, Ibieffe, Fratelli Tosetti, Reda e Rubinelli.",
    titolo8: "Senza limiti...",
    sottotitolo8:
      "Bottoni di ottima madreperla, Pvc riciclato e Corozo cuciti sapientemente con cotoni e sete di filati Guttermann e Maidera.",
    titolo9: " Web Marketing",
    sottotitolo9:
      "Continua evoluzione di materiali ecosostenibili.",
    titolo10: "Caratteristiche del configuratore 3D SHIRT",
    sottotitolo10:
      "Tutta la versatilità di una camicia... perfetta in ogni occasione!",
    titolo11: "AMPIA SCELTA",
    sottotitolo11:
      "Privilegia il look che più ti rappresenta! Potrai scegliere il tuo stile tra il vasto assortimento di tessuti e le diverse tipologie di finiture.",
    titolo12: "I NOSTRI SERVIZI",
    serv1tit:"CONTATTO",
    serv2tit:"PRESA IN CARICO ORDINE",
    serv3tit:"CONFEZIONAMENTO",
    serv1des:"Seguiamo il cliente passo dopo passo, dalla presa delle misure alla scelta delle finiture, per realizzare il prodotto che più soddisfi le esigenze richieste.",
    serv2des:"Una modellista esperta prepara e sviluppa il cartamodello della camicia da cui parte il processo di produzione, svolto interamente a mano in ogni passaggio.",
    serv3des:"Una artigiana professionista si occupa della realizzazione del capo avendo cura di ogni singolo dettaglio come le cuciture realizzate a mano.",
    sottotitolo12:
      "L'applicazione è in grado di gestire tutte le fasi del processo d'acquisto, dalla gestione del carrello, e quindi prodotti e codici sconto, fino alla gestione della spedizione e del pagamento.",
    titolo13: "Creazione Account",
    sottotitolo13:
      "L'applicazione prevede la possibilità di creare un profilo utente personale che permetterà all'utente stesso di memorizzare le proprie misure e i propri acquisti.",
    newshop:
      "Da oggi 3D SHIRT permette la vendita di prodotti collegati alla tua sartoria! Non solo camicie personalizzate ma anche camicie pronte, cravatte o quello che vuoi!",
  },
  contact: {
    titolo: "Inviaci un messaggio",
    sottotitolo:
      "Contattaci per richiedere un preventivo o semplicemente per domande o suggerimenti. Ti risponderemo nel più breve tempo possibile.",
    nome: "Il tuo nome",
    telefono: "Il tuo telefono",
    email: "La tua email",
    messaggio: "Lascia un messaggio",
    invia: "Invia il messaggio",
  },
  header: {
    account: "Account",
    modificapassword: "Modifica Password",
    logout: "Logout",
    wishlist: "Wishlist",
    shopping: "Carrello",
    loggedOut: "Ora non sei più loggato.",
    loggedOutError: "Si è verificato un errore:",
    cambiaPasswordSuccess:
      "Ti è stata inviata una mail contenente un link unico per resettare la password.",
    cambiaPasswordError: "Si è verificato il seguente errore:",
  },
  coloriTip: {
    grigio: "Grigio",
    blu: "Blu",
    nero: "Nero",
    marrone: "Marrone",
    verde: "Verde",
    bianco: "Bianco",
    viola: "Viola",
    arancione: "Arancione",
    beige: "Beige",
    giallo: "Giallo",
    rosa: "Rosa",
    rosso: "Rosso",
  },
  footer: {
    account: "Account",
    login: "Login",
    logout: "Logout",
    cookie: "Gestione dei Cookie",
    privacy: "Privacy Policy",
    termini: "Termini e Condizioni",
    recesso: "Diritto di Recesso",
    contattaci: "Contattaci",
    partita: "P.IVA",
  },
  dettaglio: {
    descrizione: "Descrizione tessuto",
    comeMisure: "Come prendere le misure",
    spedizione: "Spedizione e reso",
  },
  navigazione: {
    lang: "it",
    tessuto: "Tessuto",
    scegliTessuto: "Scegli il tessuto",
    inOfferta: "In offerta",
    nonDisponibile: "Non disponibile",
    personalizza: "Personalizza",
    personalizzazione: "Personalizzazione",
    polsinoGemelli: "Polsino Gemelli",
    contrastoColletto: "Applica al Colletto",
    contrastoPolsino: "Applica ai Polsini",
    contrastoChiusura: "Applica alla Chiusura",
    chiusura: "Chiusura",
    colletto: "Colletto",
    polsino: "Polsino",
    taschino: "Taschino",
    pinces: "Pences",
    asole: "Asole",
    bottoni: "Bottoni",
    fili: "Fili",
    contrasto: "Contrasto",
    loading: "Caricamento...",
    mascherina: "Mascherina",
    maniche: "Maniche",
    durezzaTitolo: "Durezza del colletto",
    durezza1: "Rigido",
    durezza2: "Normale",
    durezza3: "Morbido",
    durezza4: "Morbidissimo",
    velaTitolo: "Vela",
    vela1: "Vela 7",
    vela2: "Vela 7.5",
    vela3: "Vela 8",
    vela4: "Vela 8.5",
    vela5: "Vela 9",
    vela6: "Collo spaziato",
    fondo: {
      titolo: "Fondo Camicia",
      classico: "Classico",
      dritto: "Dritto",
      drittoSpacchi: "Dritto con spacchi",
    },
    iniziali: {
      iniziali: "Iniziali",
      inserisciIniziali: "Inserisci le iniziali",
      tueIniziali: "Le tue iniziali...",
      stile: "Scegli lo stile",
      colore: "Scegli il colore",
      bianco: "Bianco",
      blu: "Blu",
      celeste: "Celeste",
      grigio: "Grigio",
      nero: "Nero",
      rosso: "Rosso",
      verde: "Verde",
      arancione: "Arancione",
      rosa: "Rosa",
      posizione: "Scegli la posizione",
      sopra: "Sopra",
      centro: "Centro",
      sotto: "Sotto",
      polsinoSx: "Polsino sinistro",
      polsinoDx: "Polsino destro",
      aggiungiIniziali: "Aggiungi iniziali",
      stile1: "stile",
      colore1: "colore",
      posizione1: "posizione",
    },
    misure: {
      misuraNeutra: "Camicia di prova",
      misuraNeutraTitolo: "Vuoi provare la camicia prima di acquistarla?",
      misuraNeutraTesto1:
        "Richiedi una camicia neutra con le misure selezionate, al prezzo di soli €20.00.",
      misuraNeutraTesto2:
        "Il costo della camicia di prova ti verrà scontato successivamente sull'ordine definitivo.",
      metodoTitolo: "Seleziona il tuo metodo",
      metodoTaglia: "Misure da taglia standard",
      metodoCorpo: "Misura il tuo corpo",
      metodoCamicia: "Misura una camicia che ti va bene",
      metodoInvia: "Inviaci una camicia per misurarla",
      metodoModifica: "Modifica",
      metodoInformazioni: "Informazioni",
      selezionaTaglia: "Seleziona la tua taglia...",
      selezionaVestibilita: "Seleziona la tua vestibilità...",
      selezionaCorporatura: "Seleziona la tua corporatura...",
      selezionaSpalle: "Seleziona la discesa delle spalle...",
      corporatura: {
        pancia: {
          nome: "Pancia",
          piatta: "Piatta",
          regolare: "Regolare",
          sporgente: "Sporgente",
        },
        spalle: {
          nome: "Spalle",
          alte: "Alte",
          regolari: "Regolari",
          basse: "Basse",
        },
      },

      taglie: "TAGLIE",
      Vita: "Vita",
      lunghezzaCam: "Lunghezza camicia",
      
      misure: "Misure",
      tueMisure: "Le tue misure",
      salva: "Salva le tue misure",
      errore: "Si è verificato un errore.",
      successo: "Misure salvate con successo.",
      Braccia: "Manica",
      Bicipite: "Bicipite",
      Avambraccio: "Avambraccio",
      PuntoVitaDietro: "Punto vita dietro",
      LunghezzaDavanti: "Lunghezza Davanti",
      MezzoTorace: "Mezzo Torace",
      PuntoTorace: "Punto Torace",
      MezzaManica: "Mezza Manica",
      Collo: "Collo",
      Girovita: "Girovita",
      Polso: "Polso",
      Spalle: "Spalla",
      Torace: "Torace",
      Lunghezza: "Lunghezza",
      ColloSpalla: "Collo Spalla",
      PettoGiro: "Petto Giro",
      PettoSpalla: "Petto Spalla",
      fianco: "Fianco",
      giroManica: "Giro Manica",
      vuoiAiuto: "Vuoi un aiuto con le misure?",
      provaSelezionare: "Prova a selezionare la tua taglia",
      successoCarica: "Misure caricate con successo.",
      seleziona: "Seleziona...",
      xs: "XS - 36",
      s: "S - 37/38",
      m: "M - 39/40",
      l: "L - 41/42",
      xl: "XL - 43/44",
      xxl: "XXL - 45/46",
      xxxl: "XXXL - 47/48",
      oppure: "oppure",
      stoCaricando: "Sto caricando...",
      carica: "Carica le tue misure",
      inviaTitolo: "Inviaci la camicia da misurare",
      inviaParag1:
        "Vuoi duplicare le misure di una camicia in tuo possesso, ma non sai come misurarla correttamente?",
      inviaParag2:
        "Inviaci la tua camicia ed i nostri esperti la misureranno e conserveranno le tue misure per i prossimi acquisti. *Nota che alla tua camicia non verrà arrecato alcun danno e ti verrà rispedita nel modo migliore possibile.",
      inviaParag3: "Invia a:",
      inviaTitolo2: "Quando invii, sii sicuro di includere:",
      inviaLista1: "La camicia che vuoi farci misurare",
      inviaLista2: "Il tuo nome",
      inviaLista3: "Un recapito telefonico",
      inviaLista4: "Il tuo indirizzo email",
      inviaLista5: "L'indirizzo di spedizione",
      inviaLista6: "Eventuali istruzioni particolari",
      infoTipoMisure: "Tipo misure:",
      infoTipoMisure0: "misure da taglia",
      infoTipoMisure1: "misure da corpo",
      infoTipoMisure2: "misure da camicia",
      infoTipoMisure3: "invierà una camicia da misurare",
      infoTagliaSelezionata: "taglia selezionata:",
      infoVestibilita: "Vestibilità",
    },
  },

  barraAcquisto: {
    lang: "it",
    camicia: "Camicia",
    nonDisponibile: "Tessuto non disponibile.",
    tooltip: "Aggiungi la camicia al carrello",
    carrello: "Aggiungi al carrello",
    tessuto: "Tessuto ",
    di: " di ",
    aggiunta: "Camicia aggiunta al carrello.",
    aggiunta1: "La camicia è stata aggiunta al carrello con successo.",
    aggiunta2: "Cosa desideri fare ora?",
    continua: "Continua lo shopping",
    vai: "Carrello",
    wishlist: {
      lang: "it",
      nuovoPrezzo: "Nuovo prezzo",
      nonDisponibile: "Attenzione, tessuto non disponibile!",
      wishlist: "Wishlist",
      vuota: "La tua Wishlist è vuota!",
      Camicia: "Camicia",
      tooltip: "Aggiungi la camicia alla wishlist",
      successo: "Camicia aggiunta alla wishlist con successo.",
      rimossa: "Camicia rimossa dalla wishlist con successo.",
      Prodotto: "Prodotto",
      Prezzo: "Prezzo",
      Descrizione: "Descrizione",
      Tessuto: "Tessuto",
      Disegno: "Disegno",
      Colletto: "Colletto",
      Italiano: "Italiano",
      "Italiano Classico": "Italiano Classico",
      "Francese Classico": "Francese Classico",
      "Francese Semiaperto": "Francese Semiaperto",
      "Francese Semiaperto due bottoni": "Francese Semiaperto due bottoni",
      "Botton Down Classico": "Button Down Classico",
      "Botton Down Alto due bottoni": "Button Down Alto due bottoni",
      Diplomatico: "Diplomatico",
      Coreano: "Coreano",
      "Polsino Arrotondato": "Polsino Arrotondato",
      "Polsino Smussato": "Polsino Smussato",
      "Polsino Gemelli": "Polsino Gemelli",
      "Manica Corta": "Manica Corta",
      Chiusura: "Chiusura",
      "Faldoncino Interno non Impunturato": "Francese",
      "Faldoncino Esterno Impunturato": "Standard",
      "Finta Doppia e bottoni nascosti": "Nascosta",
      "Nessun Taschino": "Nessun Taschino",
      "Taschino Arrotondato": "Taschino Arrotondato",
      "Taschino Smussato": "Taschino Smussato",
      "Due Taschini Arrotondati": "Due Taschini Arrotondati",
      "Due Taschini Smussati": "Due Taschini Smussati",
      "Dietro Liscio": "Dietro Liscio",
      "Dietro con Doppie Pinces": "Dietro con Doppie Pinces",
      "Dietro con Doppia Piega": "Dietro con Doppia Piega",
      "Asola Bianca": "Asola Bianca",
      "Asola Blu": "Asola Blu",
      "Asola Celeste": "Asola Celeste",
      "Asola Grigia": "Asola Grigia",
      "Asola Nera": "Asola Nera",
      "Asola Rossa": "Asola Rossa",
      "Bottone Bianco": "Bottone Bianco",
      "Bottone Blu": "Bottone Blu",
      "Bottone Celeste": "Bottone Celeste",
      "Bottone Grigio": "Asola Grigia",
      "Bottone Nero": "Bottone Grigio",
      "Bottone Rosso": "Bottone Rosso",
      "Filo Bianco": "Filo Bianco",
      "Filo Blu": "Filo Blu",
      "Filo Celeste": "Filo Celeste",
      "Filo Grigio": "Filo Grigia",
      "Filo Nero": "Filo Grigio",
      "Filo Rosso": "Filo Rosso",
      Contrasto: "Contrasto",
      contrastoPolsino: "Polsino",
      contrastoColletto: "Colletto",
      contrastoChiusura: "Chiusura",
      Stile: "Stile",
      Iniziali: "Iniziali",
      iniStile: "Stile",
      iniColore: "Colore",
      iniPosizione: "Posizione",
      white: "Bianco",
      slateblue: "Blu",
      lightsteelblue: "Celeste",
      lightgray: "Grigio",
      black: "Nero",
      crimson: "Rosso",
      posizione: "Scegli la posizione",
      sopra: "Sopra",
      centro: "Centro",
      sotto: "Sotto",
      rimuovi: "Rimuovi dalla Wishlist",
      importa: "Importa nel configuratore",
      torna: "Torna al configuratore",
    },
  },
  tutorial: {
    braccia: {
      header: "Manica",
      titolo: "Misura della manica",
      descrizione:
        "Misura la manica dalla spalla sino al polso tenendo il braccio piegato a 90°.",
    },
    mezzaManica: {
      header: "Mezza Manica",
      titolo: "Misura della mezza manica",
      descrizione:
        "Misura la manica dalla spalla sino alla lunghezza desiderata per un minimo di 18cm e un massimo di 30cm",
    },
    bicipite: {
      header: "bicipite",
      titolo: "Misura del bicipite",
      descrizione:
        "Misura il bicipite/tricipite a cm. 16 partendo dal punto esterno della spalla.",
    },
    avambraccio: {
      header: "avambraccio",
      titolo: "Misura dell'avambraccio",
      descrizione: "Misura l'avambraccio appena sotto il gomito.",
    },
    fianco: {
      header: "Fianco",
      titolo: "Misura del Fianco",
      descrizione:
        "Misura il fianco all'altezza della fine della tasca dei pantaloni passando per l'altezza a meta' dei glutei.",
    },
    puntoVitaDietro: {
      header: "Fianco",
      titolo: "Misura del punto vita dietro",
      descrizione:
        "Misura partendo dall'attaccatura dietro del collo fino ad intercettare il punto più stretto in vita ( misure slim).",
    },
    mezzoTorace: {
      header: "mezzo torace",
      titolo: "Misura del mezzo torace",
      descrizione:
        "Misura la distanza (indossando una camicia ) tra l'attaccatura del carrè al collo scendendo verso il basso (per persone corpulente). ",
    },
    puntoTorace: {
      header: "punto torace",
      titolo: "Misura del punto torace",
      descrizione:
        "Misura dall'attaccatura del carrè al collo fino al capezzolo sul torace ( determina l'altezza del torace).",
    },
    lunghezzaDavanti: {
      header: "lunghezza davanti",
      titolo: "Misura della lunghezza davanti",
      descrizione:
        "Misura dall'attaccatura del torace al braccio al centro torace.",
    },
    bracciaCamicia: {
      header: "Braccia",
      titolo: "Misura delle braccia",
      descrizione:
        "Misura la manica dalla cucitura più alta della spalla sino alla fine del polsino, tenendo la camicia ben stesa su una superficie piana.",
    },
    collo: {
      header: "Collo",
      titolo: "Misura del collo",
      descrizione:
        "Far scorrere il metro intorno al collo e misurare subito sotto il pomo di Adamo. E' importante inserire un dito tra il metro ed il collo per garantire una vestibilità confortevole.",
    },
    colloCamicia: {
      header: "Collo",
      titolo: "Misura del collo",
      descrizione:
        "Misura la distanza lineare fra il bottone del colletto e l'asola corrispondente, tenendo il colletto ben aperto e steso su una superficie piana.",
    },
    girovita: {
      header: "Girovita",
      titolo: "Misura del girovita",
      descrizione:
        "Misura il giro vita nel punto più ampio all'altezza dell'ombelico lasciando un dito tra il corpo ed il metro. Per una corretta vestibilità bisogna far aderire il metro alla vita lasciando sempre un dito di tolleranza tra il corpo ed il metro.",
    },
    girovitaCamicia: {
      header: "Girovita",
      titolo: "Misura del girovita",
      descrizione:
        "Misura il giro vita nel punto più ampio all'altezza dell'ombelico, fra il secondo e il terzo bottone dal basso, tenendo la camicia ben stesa su una superficie piana.. Se hai fianchi ampi è consigliabile prendere la misura leggermente più in basso, per comprenderli nel totale.",
    },
    polso: {
      header: "Polso",
      titolo: "Misura del polso",
      descrizione:
        "Misura la circonferenza del polso all'altezza dell'articolazione.",
    },
    polsoCamicia: {
      header: "Polso",
      titolo: "Misura del polso",
      descrizione:
        "Misura la distanza lineare fra il bottone del polsino e l'asola corrispondente, tenendo il polsino ben aperto e steso su una superficie piana.",
    },
    spalle: {
      header: "Spalle",
      titolo: "Misura delle spalle",
      descrizione: "Misurare la larghezza delle spalle nel punto più ampio.",
    },
    spalleCamicia: {
      header: "Spalle",
      titolo: "Misura delle spalle",
      descrizione: "Misurare la larghezza delle spalle nel punto più ampio.",
    },
    torace: {
      header: "Torace",
      titolo: "Misura del torace",
      descrizione:
        "Misura la circonferenza del torace all'altezza del petto. Per una corretta vestibilità bisogna far aderire il metro al torace conservando sempre un dito di tolleranza tra il corpo ed il metro in modo da potersi muovere in libertà.",
    },
    toraceCamicia: {
      header: "Torace",
      titolo: "Misura del torace",
      descrizione:
        "Misura la circonferenza del torace all'altezza del petto, fra il secondo ed il terzo bottone dall'alto. Misura la distanza lineare fra il bottone e l'opposta asola corrispondente.",
    },
    lunghezza: {
      header: "Lunghezza",
      titolo: "Misura della lunghezza",
      descrizione:
        "Inclina la testa in avanti e  misura dal centro della base posteriore del collo, fino al cavallo dei pantaloni.",
    },
    lunghezzaCamicia: {
      header: "Lunghezza",
      titolo: "Misura della lunghezza",
      descrizione:
        "Tenendo la camicia ben stesa su una superficie piana  misura dal centro della base posteriore del collo, in  corrispondenza del centro della cucitura fra camicia e colletto, fino all'orlo inferiore.",
    },
    colloSpalla: {
      header: "Collo Spalla",
      titolo: "Collo Spalla",
      descrizione:
        "Misura la distanza dall'attaccamento del collo all'estremità della spalla. È importante per determinare se si desidera una spalla precisa 'sartoriale' o più casual 'Large'.",
    },
    pettoGiro: {
      header: "Petto Giro",
      titolo: "Petto Giro",
      descrizione:
        "Misura il davanti tra il secondo e il terzo bottone fino alla cucitura della manica.",
    },
    pettoSpalla: {
      header: "Petto Spalla",
      titolo: "Petto Spalla",
      descrizione:
        "Misura dal collo fino alla cucitura della manica con la spalla.",
    },

    giroManica: {
      header: "Giro Manica",
      titolo: "Giro Manica",
      descrizione:
        "Misura il giromanica all'altezza della spalla, lasciando un dito tra il metro e il braccio.",
    },
  },
  contatti: {
    richiesto: "Campo richiesto",
    emailInvalida: "Indirizzo email non valido",
    titolo: "Noi adoriamo dialogare con te",
    successo: "Grazie. Il tuo messaggio è stato inviato con successo.",
    errore: "Attenzione. Si è verificato un errore.",
    nome: "Nome *",
    email: "Email *",
    oggetto: "Oggetto *",
    messaggio: "Messaggio *",
    attendere: "Attendere...",
    invia: "Invia",
    testo01:
      "OGNI ORDINE HA BISOGNO DI ALMENO 20 GIORNI LAVORATIVI PRIMI DI ESSERE SPEDITO.CI SCUSIAMO PER IL DISAGIO MA LA VOSTRA CAMICIA NON SARÀ COME TUTTE LE ALTRE.",
    testo02:
      "La Sartoria Turrisi è a Ceglie Messapica, accogliente cittadina della Provincia di Brindisi, nel sud della Puglia.",
    testo03:
      "Dal 1970 tramandiamo la forte tradizione sartoriale, la nostra è una piccola azienda artigianale che opera con passione in ogni fase della lavorazione, eseguita esclusivamente all’interno della nostra sartoria da manodopera italiana altamente specializzata.",
    testo04:
      "La scelta dei tessuti e degli accessori di ottima qualità ci consentono di offrire l’eccellenza dell’autentico “Made in Italy”.",
    testo05:
      "Il nostro obiettivo è quello di soddisfare sotto ogni aspetto il nostro cliente, offrendo la nostra esperienza nel settore.",
    testo06:
      "Oggi è possibile confondere uno scultore con un sarto, perché tutti e due creano delle forme.",
    testo07: "KARL KRAUS",
    testo08: "TOCCA CON MANO LA NOSTRA SELEZIONE DI TESSUTI.",
    testo09: "ORDINA ORA IL TUO KIT GRATUITO!",
  },
  pagina404: {
    errore: "Errore 404",
    nonEsiste: "La pagina che cerchi non esiste!",
    torna: "Torna al configuratore",
  },
};
